module.exports = "/wwwroot/img/waste_search_block.png?ver=932152de";